import { ColumnLayout } from "@mittwald/flow-components/dist/components/ColumnLayout";
import { useFormContext } from "@mittwald/flow-components/dist/components/Form";
import { Section } from "@mittwald/flow-components/dist/components/Section";
import { TextArea } from "@mittwald/flow-components/dist/components/TextArea";
import { TextField } from "@mittwald/flow-components/dist/components/TextField";
import TranslationProvider from "@mittwald/flow-components/dist/components/TranslationProvider/TranslationProvider";
import useSelector from "@mittwald/flow-lib/dist/hooks/useSelector";
import React, { useEffect } from "react";
import User from "../../../../../../model/user/User";
import PhoneNumberInput from "../../../../../../pages/app/components/PhoneNumberInput";
import type { RelocationFormData } from "../../../RelocationRequestWidget";
import { relocationWidgetStore } from "../../../store/RelocationWidgetStore";
import { LegacySystemAPI } from "../../../utils/LegacySystemAPI";
import {
  isNewSystem,
  updateInformationByUser,
} from "../../../utils/RelocationUtils";
import { StepHeaderItem } from "../../StepHeaderItem";
import { Section as NewSection } from "@mittwald/flow-react-components";

export const ContactStepContent: React.FC = () => {
  const form = useFormContext<RelocationFormData>();

  const customerNumber = useSelector(
    () => relocationWidgetStore.customerNumber,
  );

  useEffect(() => {
    if (isNewSystem(form)) {
      void User.me().then((user) => {
        updateInformationByUser(form, user);
      });
    } else {
      void LegacySystemAPI.getContractPartner(customerNumber).then(
        (contractPartner) => {
          updateInformationByUser(form, contractPartner);
        },
      );
    }
  }, []);

  return (
    <TranslationProvider name="contactStepContent" type="component">
      <NewSection>
        <StepHeaderItem description="description" headline="headline" />
      </NewSection>
      <NewSection>
        <Section.Item>
          <ColumnLayout medium={[1, 1]}>
            <TextField
              label="firstName"
              name="contact.firstName"
              rules={{
                required: true,
              }}
            />
            <TextField
              label="lastName"
              name="contact.lastName"
              rules={{
                required: true,
              }}
            />
            <TextField
              label="email"
              name="contact.email"
              rules={{
                required: true,
              }}
              type="email"
            />
            <PhoneNumberInput name="contact.phoneNumber" />
          </ColumnLayout>
          <TextArea
            infoMessage={{
              message: "notes.infoMessage",
            }}
            label="note"
            name="notes"
          />
        </Section.Item>
      </NewSection>
    </TranslationProvider>
  );
};
